import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import {
  State, getApplicationState, ArcGisTokenAboutToExpire
} from 'src/app/state-management';

@Injectable({
  providedIn: 'root'
})
export class ArcGisTokenGuard  {
  constructor(private store: Store<State>, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(getApplicationState).pipe(
      first(),
      mergeMap(applicationState => {
        if (ArcGisTokenAboutToExpire(applicationState.arcGisToken)) {
          if (route.params) {
            let temp = Object.assign({}, route, {
              params: {
                ...route.params,
                '_loadingTo': ''
              }
            })

            if (!route.paramMap.has('_loadingTo') && route?.routeConfig?.path && route.routeConfig.path != 'loading') {
              temp.params['_loadingTo'] = route.routeConfig.path;

            }
            return of(this.router.createUrlTree(['loading', temp.params], { queryParams: route.queryParams }));
          } else {
            return of(this.router.parseUrl('/'));
          }
        } else {
          return of(true);
        }
      })
    );
  }

}
